<div class="dialog-container">
  <div class="dialog-header">
    <div class="dialog-icon">
      <mat-icon>hotel</mat-icon>
    </div>
    <div>
      <h2 class="dialog-title">Choose accommodation</h2>
      <p class="dialog-subtitle">Select the stay to use for activities.</p>
    </div>
  </div>

  <div class="dialog-body" *ngIf="data?.items?.length > 0">
    <button
      mat-stroked-button
      class="item-card"
      type="button"
      *ngFor="let item of data.items"
      (click)="selectItem(item)"
    >
      <div class="item-main">
        <div class="item-header">
          <span class="item-title">{{ item.supplier || item.service || 'Accommodation' }}</span>
          <span class="item-chip">Stay</span>
        </div>
        <span class="item-location">{{ item.to || item.service || 'Location not set' }}</span>
        <span class="item-dates" *ngIf="item.start && item.end">
          {{ item.start | date:'dd MMM yy' }} - {{ item.end | date:'dd MMM yy' }}
        </span>
      </div>
      <mat-icon class="item-arrow">chevron_right</mat-icon>
    </button>
  </div>

  <div class="dialog-actions">
    <button mat-button type="button" (click)="close()">Cancel</button>
  </div>
</div>
